<template>
    <section id="contact" class="contact-area bg-gray ptb_100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-6">
                    <!-- Section Heading -->
                    <div class="section-heading text-center">
                        <h2 class="text-capitalize">Stay Tuned</h2>
                        <p class="d-sm-block mt-4">Women's rules flashcards and quizzes are being curated! Let us know what you want to see in the next update by submitting the form below. Follow us on social media @byruleapp for news, answers to common rule questions, giveaways and more! </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <!-- Contact Box -->
                    <div class="contact-box text-center">
                        <!-- Contact Form -->
                        <form id="contact-form" @submit.prevent="sendEmail">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="name" name="name" placeholder="Name" required="required">
                                    </div>
                                    <div class="form-group">
                                        <input type="email" class="form-control" v-model="email" name="email" placeholder="Email" required="required">
                                    </div>
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="subject" name="subject" placeholder="Subject" required="required">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <textarea class="form-control" v-model="message" name="message" placeholder="Message" required="required"></textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-bordered mt-3 mt-sm-4" type="submit">Send Message</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import emailjs from 'emailjs-com';

export default {
    data() {
        return {
            name: '',
            email: '',
            subject: '',
            message: ''
        }
    },
    methods: {
        sendEmail(e) {
            try {
        emailjs.sendForm('service_1j5i33l', 'template_i9clt6h', e.target,
        'user_pX7XLlJXbsQD9L0EArsbb', {
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        })

      } catch(error) {
          console.log({error})
      }
      // Reset form field
      this.name = ''
      this.email = ''
      this.message = ''
      this.subject = ''
        }
    }
}
</script>

<style>

</style>